import { Link } from "react-router-dom";

import '../assets/css/footer.css';
import { Container, Row, Col } from "react-bootstrap";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaLocationArrow  } from "react-icons/fa";

const Footer = ({serviceslist}) => {
  return (
    <footer className="bg-footer py-4">
      <Container>
        <Row>
          {/* Column 1 */}
          <Col xs={12} md={4} className="mb-3">
            <h4 className='footer-heading'>Contact Us</h4>
            <ul className="list-unstyled address-li">
                    <li>
                        <span style={{verticalAlign: "top",lineHeight: 0,height: "84px",position: "relative",display: "inline-block",width: "5%",paddingTop: "6px"}}>
                            <FaMapMarkerAlt className='jishna' />
                        </span>
                        <span className="address" style={{display: "inline-block",position: "relative", width: "91%"}}>
                        Flat No: 302, Sarva's Residency,<br />APHMEL Bypass Road,Kondapalli, <br />NTR District, Andhra Pradesh - 521228 India 
                        </span>
                    </li>
                    <li>
                        <span><FaPhoneAlt className='jishna' /> +91 9705363764, +91 9490896984</span>
                    </li>
                    <li>
                        <span><FaEnvelope className='jishna' /> &nbsp; jishnageotechsolutions@gmail.com</span>
                    </li>
                    <li><span><b className="jishna">GSTIN</b> : 37AAVFJ0309A1ZL</span></li>
                    <li className="mt-2">
                        <span className="locate_us jishna">
                            <a href="https://maps.app.goo.gl/LAKzHKpNQ4snc4J27" target="_blank" rel="noreferrer" className='jishna'>
                                <FaLocationArrow />&nbsp; View on Maps 
                            </a>
                        </span>
                    </li>
                    {/*  social media links  */}
                    {/* <li class="media_links mt-4 align-items-center">
                        <p class="social text-muted mb-0 pb-0 bold-text"> 
                            <a href="#"><span class="mx-2"><i class="fa fa-facebook fa-2x" aria-hidden="true"></i></span> </a>
                            <a href="#"><span class="mx-2"><i class="fa fa-linkedin-square fa-2x" aria-hidden="true"></i></span> </a>
                            <a href="#"><span class="mx-2"><i class="fa fa-twitter fa-2x" aria-hidden="true"></i></span> </a>
                            <a href="#"><span class="mx-2"><i class="fa fa-instagram fa-2x" aria-hidden="true"></i></span> </a>
                        </p>
                    </li> */}
                </ul>
          </Col>

          {/* Column 2 */}
          <Col xs={12} md={4} className="mb-3">
            <h4 className='jishna'>Our Services</h4>
            <ul className='list-unstyled serices-list'>
            { serviceslist.map((item, index) => (
                <li key={index}>
                    <Link to={`/service/${item.path}`}>{item.title}</Link>
                </li>   
            ))}
            </ul>
          </Col>

          {/* Column 3 */}
          <Col xs={12} md={4} className="mb-3">
            <h4 className='jishna'>Why Collaborate With Us</h4>
            <p className='collaborate'>
                Partnering with <b className="jishna">Jishna Geo Tech Solutions</b> brings extensive expertise in geological, geophysical and geotechnical services, enhancing decision-making and resource management. We offer training, innovative solutions, and comprehensive services in mapping, exploration, and environmental assessments. Join us for cutting-edge solutions to complex geological challenges.
            </p>
          </Col>
        </Row>

        <Row>
          <Col className="text-center mt-3">
            <small>© 2026 MyWebsite. All rights reserved.</small>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer